import { inject, Injectable } from '@angular/core';
import { ApiService } from '@tw/services';
import { UserEvent } from 'src/shared/models/common';

@Injectable({
  providedIn: 'root',
})
export class TrackService {
  private apiService = inject(ApiService);

  getEvents(payload: { startDate: string; endDate: string }) {
    return this.apiService.get<UserEvent[]>('user/sync-my-events', {
      params: payload,
    });
  }
  getTeamMemberEvents(payload: {
    userGuid: string;
    startDate: string;
    endDate: string;
  }) {
    return this.apiService.get<UserEvent[]>('user/sync-team-member-events', {
      params: payload,
    });
  }
}
